import React from 'react';
import { classnames } from 'Utils/classnames';
import PropTypes from 'prop-types';

export const Badge = props => {
  const { className, children, isNew } = props;

  const componentClasses = classnames({
    badge: true,
    [className]: className
  });

  const newComponentClasses = classnames({
    badgeNew: true,
    [className]: className
  });


  return <i className={ isNew ? newComponentClasses : componentClasses }>{ children }</i>;
};

Badge.propTypes = {
  /** You can pass extra classes  */
  className: PropTypes.string,

  /** Component content  */
  children: PropTypes.any,
  /** You can pass new badge  */
  isNew: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
